import "./google_map.js";

window.Sparkle ??= {};
window.Sparkle.Views ??= {};

Sparkle.Views.AddressesMap = class AddressesMap extends Sparkle.Views.GoogleMap {
  constructor(options) {
    super(options);
    this.addMarkersToMap = this.addMarkersToMap.bind(this);
    this.getMarkerOptions = this.getMarkerOptions.bind(this);
    if (options == null) {
      options = {};
    }
    this.collection = options.collection;
  }

  addMarkersToMap() {
    return jQuery.each(this.collection, (_, address) => {
      if (!address.lat || !address.lng) {
        return;
      }
      const markerOptions = this.getMarkerOptions(address);

      const marker = new google.maps.Marker(markerOptions);
      const infoWindowHTML = this.infoWindowTemplate({ name: address.name, addresses: [address] });
      return this.createInfoWindow(marker, infoWindowHTML);
    });
  }

  getMarkerOptions(address) {
    const latLng = new google.maps.LatLng(address.lat, address.lng);
    this.bounds.extend(latLng);

    return {
      position: latLng,
      map: this.mapObject,
      title: address.name,
    };
  }
};
